import { updateOrder } from '../state/dashboard';

const useDndUtils = (order) => {
  const handleDragEnd = (event) => {
    const { active, over } = event;
    const sourceIdx = order.indexOf(active.id);
    const destIdx = order.indexOf(over.id);
    // create new order
    const newOrder = Array.from(order);
    const [reorderedItem] = newOrder.splice(sourceIdx, 1);
    newOrder.splice(destIdx, 0, reorderedItem);
    updateOrder(newOrder);
  };

  return { handleDragEnd };
};

export default useDndUtils;
